import type * as Redux from '@reduxjs/toolkit';
import type { ThunkAction } from '@reduxjs/toolkit';

import type { UserBalanceResponse } from '../../declarations/ah-api';
import * as AhApi from '../api/ah-api';
import type { RootState } from '../store';
import * as types from './action-types';

export interface UserBalanceAction extends Redux.Action {
  userBalance: UserBalanceResponse;
}

export function loadUserBalance(): ThunkAction<Promise<UserBalanceResponse>, RootState, void, any> {
  return async function (dispatch: Redux.Dispatch<UserBalanceAction>, getState) {
    const { userProfile } = getState();
    const userBalance = await AhApi.getUserBalance(userProfile);
    dispatch(loadUserBalanceSuccess(userBalance));
    return userBalance;
  };
}

export function loadUserBalanceSuccess(userBalance: UserBalanceResponse): UserBalanceAction {
  return { type: types.LOAD_USER_BALANCE_SUCCESS, userBalance };
}
